if (!window.__calendlyButtonInit) {
  window.__calendlyButtonInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-calendly-button]');
    if (!button) return;

    event.preventDefault();
    if (typeof Calendly === 'undefined') return;

    var base = button.getAttribute('data-calendly-url');
    if (!base) return;

    var separator = base.indexOf('?') === -1 ? '?' : '&';
    var url = base + separator + 'utm_content=' + encodeURIComponent(window.location.href);
    Calendly.initPopupWidget({ url: url });
  });
}
